module.exports = __webpack_public_path__ + "img/11d.8d5deced.png";